import { useQuery } from '@tanstack/react-query';
import { ApiError } from 'src/types/interfaces/api-error';

import { visitsApi } from '../../api/lib/visits';
import { visitsKeys } from '../../api/query-keys/visits';
import { Visit } from '../../api/types/visits';

export const useVisit = (id: number) => {
  return useQuery<Visit, ApiError>({
    queryKey: visitsKeys.detail(id),
    queryFn: () => visitsApi.fetchVisit(id),
  });
};
